<template>
  <template-info :bgImg="bgImg" title="VAT คืออะไร">
    <div>
      <div class="wivb-detail">
        <span>VAT</span> คือ ภาษีมูลค่าเพิ่มที่จัดเก็บจากการขายสินค้า
        (และให้บริการ) ในอัตรา 7%
      </div>

      <div class="wivb-detail">
        <span>ภาษีขาย</span> คือ ภาษีมูลค่าเพิ่มที่คุณเรียกเก็บจากลูกค้า
        เมื่อขายสินค้า และให้บริการ เช่น ขายสินค้าราคา 100 บาท
        เราจะเก็บเงินจากลูกค้ามา 107 บาท ซึ่ง 7 บาทนี้เรียกว่า “ภาษีขาย”
      </div>

      <div class="wivb-detail">
        <span>ภาษีซื้อ</span> คือ ภาษีมูลค่าเพิ่มที่คุณจ่ายให้แก่ผู้ขายที่จด
        ทะเบียนภาษีมูลค่าเพิ่ม เมื่อซื้อสินค้าและรับบริการ เช่น
        เราไปซื้อของมาราคา 50 บาท เราก็ต้องจ่ายเงินซื้อของ ไป 53.50 บาท ซึ่ง
        3.50 บาทนี้เรียกว่า “ภาษีซื้อ” โดยคำนวณจาก VAT 7%
      </div>
    </div>
    <chevron-right-link @clickLink="goVatBenefit" caption="ทำไมต้องจด VAT" />
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/vat_definition.png";

export default {
  name: "VatDefinition",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
  methods: {
    goVatBenefit() {
      this.$router.push({
        path: "/info/vat_benefit",
      });
    },
  },
};
</script>

<style scoped>
.wivb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 20px;
  text-align: left;
}
.wivb-detail > span {
  font-weight: bold;
}
</style>
